// Shared client/server constants for the community feed. Two pieces only —
// the archetype-tag vocabulary and the rental-code shape regex — both used
// by `src/server/routes/community.ts` (validation) and by `PublishDialog`
// in `src/web/components/TeamCard.tsx` (the chip picker + form check).
//
// Keep this module free of heavy dependencies (no Drizzle, no @pkmn/*) so
// both surfaces can import it without bloating the web bundle.

export const ARCHETYPE_TAGS = [
  'sun',
  'rain',
  'trick-room',
  'tailwind',
  'balance',
  'hyper-offense',
  'stall',
  'ogerpon',
  'kingambit',
  'char-y',
] as const;

export type ArchetypeTag = (typeof ARCHETYPE_TAGS)[number];

// Champions rental codes are 10 chars in the shape XXXX-XXXX-XX, where each
// position is uppercase alphanumeric. The hyphens are mandatory.
export const REPLICA_CODE_RE = /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{2}$/;
